var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlbania(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_42)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 40.0001C31.0456 40.0001 39.9999 31.0458 39.9999 20.0001C39.9999 8.95443 31.0456 0.00012207 19.9999 0.00012207C8.95418 0.00012207 -0.00012207 8.95443 -0.00012207 20.0001C-0.00012207 31.0458 8.95418 40.0001 19.9999 40.0001Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3042 14.8444H24.06C24.5072 14.3761 24.7824 13.7422 24.7824 13.0435C24.7824 11.6028 23.6145 10.4348 22.1738 10.4348C21.2661 10.4348 20.4671 10.8986 19.9999 11.6018C19.5326 10.8986 18.7335 10.4348 17.8259 10.4348C16.3852 10.4348 15.2173 11.6028 15.2173 13.0435C15.2173 13.7422 15.4925 14.3762 15.9397 14.8444H8.69556C8.69556 16.7654 10.3688 18.3226 12.2896 18.3226H12.1737C12.1737 20.2437 13.7309 21.801 15.652 21.801C15.652 22.4232 15.816 23.0065 16.1023 23.5115L13.2171 26.3967L15.4307 28.6101L18.5707 25.4702C18.6937 25.5153 18.8209 25.5515 18.9524 25.5761L17.0549 29.8601L19.9999 33.0435L22.9448 29.8599L21.0474 25.5759C21.1788 25.5513 21.306 25.5152 21.429 25.47L24.569 28.61L26.7826 26.3965L23.8974 23.5112C24.1837 23.0063 24.3477 22.4229 24.3477 21.8008C26.2687 21.8008 27.826 20.2436 27.826 18.3224H27.7101C29.631 18.3225 31.3042 16.7654 31.3042 14.8444V14.8444Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_42"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlbania);
export default __webpack_public_path__ + "static/media/albania.04d351de81103d88eb958fa906407c13.svg";
export { ForwardRef as ReactComponent };